import styled, { css, keyframes } from 'styled-components';

export const gentleBlinking = keyframes`
  0% {
    opacity: 0.6;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

export const Caret = styled.div`
  display: flex;
  flex-shrink: 0;
  max-width: 4px;
  min-height: 25px;
  background: var(--cl-yellow-200);
  border-radius: var(--cl-radius-1);
  transition: all 200ms ease;
  animation: ${gentleBlinking} 3000ms ease infinite;

  &:focus-within {
    position: relative;
    right: 0;
    min-width: 4px;
    max-width: 1000px;
  }
`;

export const HiddenCaret = styled.div<{
  inlineSuggestion?: boolean;
}>`
  position: relative;
  display: flex;
  flex-shrink: 0;
  width: 7px;
  height: 25px;
  border-radius: var(--cl-radius-2);
  transition: all 200ms ease;
  caret-color: transparent;
  align-items: center;
  z-index: 1;

  &:hover {
    background: var(--cl-yellow-300);
    animation: ${gentleBlinking} 3000ms ease infinite;
  }

  ${({ inlineSuggestion }) => inlineSuggestion && css`
    animation: ${gentleBlinking} 1000ms ease infinite;
    color: var(--cl-gray-500);

    &:before {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      left: 0;
    }

    &:hover {
      right: 0;
      color: var(--cl-yellow-400);
      font-family: var(--cl-font-family-mono);
      font-size: var(--cl-font-size-2);
      font-weight: bold;
      width: 10px;
      margin: 0 3px;
    }
  `}
`;
